import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { type MetricsParams, metricsResponse, type UseMetrics } from './Metrics.schema';

const METRICS_QUERY_KEY = ['metrics'];

export const metricsKeys = {
	all: METRICS_QUERY_KEY,
	byParams: (params: MetricsParams) => [...METRICS_QUERY_KEY, params] as const,
};

export const useMetrics = (params: MetricsParams, opts: UseMetrics['opts'] = {}) =>
	useQuery<UseMetrics['response']>({
		...opts,
		queryKey: metricsKeys.byParams(params),
		queryFn: () => API.get('/metrics', { params }).then((res) => metricsResponse.parse(res.data)),
		staleTime: 30_000,
	});
